angular.module('v3sWbtPlayerApp').factory('v3sExerciseService', ["$rootScope", function ($rootScope) {

    var exercise = null;

    function init(page, type, instantMode, maxAttempts, exDifficulty) {
        exercise = page.initExercise({
            type: type,
            instantMode: instantMode,
            maxAttempts: maxAttempts,
            difficulty: exDifficulty || null
        });
    }

    function subscribeExerciseChanged(scope, callback) {
        var handler = $rootScope.$on('v3sExerciseChanged', callback);
        scope.$on('$destroy', handler);
    }

    function destroy() {
        if (exercise) {
            exercise.complete(true);
        }

        exercise = null;
    }

    function checkAllExercisesLast(options) {
        options = options || {};
        options.lastTestEvaluation = true;

        exercise.evaluate(options);
    }

    return {
        init: init,
        isInited: function () { return exercise != null; },
        getExerciseType: function () { return exercise.getType(); },
        addExercise: function (element) { exercise.addExerciseElement(element); },
        getExerciseData: function (element) { return exercise.getExerciseElementData(element); },
        updateExercise: function (element, data) {
            exercise.updateExerciseElement(element);
            exercise.setExerciseElementData(element, data);
        },
        checkAllExercises: function () { return exercise.evaluate(); },
        checkAllExercisesLast: checkAllExercisesLast,
        complete: function () { return exercise && exercise.complete(true); },
        isAnswered: function () { return exercise.isAnswered(); },
        isCompleted: function () { return exercise.isCompleted(); },
        subscribeExerciseChanged: subscribeExerciseChanged,
        isExerciseEvaluationVisible: function () { return exercise.isExerciseEvaluationVisible(); },
        isIgnoreNavigationSetting: function () { return exercise && exercise.isIgnoreNavigationSetting(); },
        destroy: destroy
    };
}]);